import {Component, ChangeDetectionStrategy} from '@angular/core';
import {AppContext} from '../app-context';

@Component({
    selector: 'app-alerting',
    templateUrl: './alerting.component.html',
    styleUrls: ['./alerting.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AlertingComponent {
  appContext = AppContext;
  maxAlertCount = 2;
}
